import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 6C21.75 5.80109 21.671 5.61032 21.5303 5.46967C21.3897 5.32902 21.1989 5.25 21 5.25L16.75 5.25V3C16.75 2.58579 16.4142 2.25 16 2.25L5 2.25C3.48122 2.25 2.25 3.48122 2.25 5L2.25 18C2.25 18.4142 2.58579 18.75 3 18.75H6.25V19C6.25 20.5188 7.48122 21.75 9 21.75H21C21.4142 21.75 21.75 21.4142 21.75 21V6ZM7.75 18L7.75 19C7.75052 19.6899 8.30996 20.25 9 20.25C9.69036 20.25 10.25 19.6904 10.25 19V6C10.25 5.80109 10.329 5.61032 10.4697 5.46967C10.6103 5.32902 10.8011 5.25 11 5.25L15.25 5.25V3.75L7.45015 3.75C7.64186 4.12503 7.75 4.54989 7.75 5L7.75 18ZM3.75 17.25L3.75 15.8036H6.25V17.25H3.75ZM20.25 6.75V8.19644L11.75 8.19644L11.75 6.75H20.25Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
